import { Listbox, Menu, Switch } from "@headlessui/react";
import React, { useMemo, useState } from "react";
import { BiLoaderCircle } from "react-icons/bi";
import DatePicker from "react-datepicker";
import { FaCheck } from "react-icons/fa";
import ProcessingBar2 from "./ProcessingBar/ProcessingBar2";
import { useEffect } from "react";

export function Input({
  label,
  name,
  type,
  color,
  placeholder,
  register,
  value,
  onChange,
  onBlur,
}) {
  return (
    <div className="text-sm w-full">
      <label
        className={`${
          color ? "text-yellowlight text-lg" : "text-text font-semibold"
        } `}
      >
        {label}
      </label>
      <input
        name={name}
        {...register}
        type={type}
        placeholder={placeholder}
        value={value} // ✅ Add this
        onChange={onChange} // ✅ Add this
        onBlur={onBlur}
        className={`w-full bg-transparent text-sm mt-3 p-4 border ${
          color
            ? "border-yellowlight font-light"
            : "border-neutral-500 text-white"
        } rounded-lg focus:border focus:border-subMain`}
      />
    </div>
  );
}

// button

export function Button({ label, onClick, loading, Icon, type = "button" }) {
  return (
    <button
      type={type}
      {...(type !== "submit" && { onClick })}
      disabled={loading}
      className="w-full flex-rows gap-4 hover:opacity-80 transitions bg-navy text-border text-sm font-medium px-2 py-4 rounded"
    >
      {loading ? (
        <ProcessingBar2 />
      ) : (
        <>
          {label}
          {Icon && <Icon className="text-border text-xl" />}
        </>
      )}
    </button>
  );
}

// select

export function MenuSelect({ children, datas, item: data }) {
  return (
    <div className="text-sm w-full relative">
      <Menu>
        <Menu.Button>{children}</Menu.Button>
        <Menu.Items className="flex flex-col z-50 gap-4 absolute left-0  bg-main text-text rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none">
          {datas.map((item, index) => (
            <button
              onClick={() => item.onClick(data)}
              key={index}
              className={`flex gap-4 items-center hover:text-subMain`}
            >
              {item.icon && <item.icon className="text-md text-subMain" />}
              {item.title}
            </button>
          ))}
        </Menu.Items>
      </Menu>
    </div>
  );
}

// select 2

// export default function MultiSelect({
//   selectedItems,
//   items,
//   setSelectedItems,
//   title,
// }) {
//   const categories = [...new Set(items.map((item) => item.category))];

//   const allCategories = [...new Set(items.map((item) => item.category)), "all"];

//   const toggleSelection = (category) => {
//     const categoryItems = items.filter((item) => item.category === category);
//     const categoryIds = categoryItems.map((item) => item.id);

//     setSelectedItems((prevSelected) => {
//       const isSelected = categoryIds.every((id) => prevSelected.includes(id));
//       return isSelected
//         ? prevSelected.filter((id) => !categoryIds.includes(id))
//         : [...new Set([...prevSelected, ...categoryIds])];
//     });
//   };

//   return (
//     <div className="relative w-full text-sm">
//       <Listbox value={selectedItems} onChange={setSelectedItems} multiple>
//         <Listbox.Button className="w-full bg-dry p-2 rounded-md border border-border text-text">
//           Select {title}
//         </Listbox.Button>
//         <Listbox.Options className="absolute z-50 w-full bg-white rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none">
//           {allCategories.map((category) => (
//             <Listbox.Option
//               key={category}
//               value={category}
//               className={`cursor-pointer text-xs text-text hover:text-subMain p-2 rounded-md`}
//               onClick={() => toggleSelection(category)}
//             >
//               {category}
//             </Listbox.Option>
//           ))}
//         </Listbox.Options>
//       </Listbox>
//     </div>
//   );
// }

// export default function MultiSelect({
//   selectedItems,
//   items,
//   setSelectedItems,
//   title,
// }) {
//   const [expandedCategories, setExpandedCategories] = useState([]);
//   const categories = [...new Set(items.map((item) => item.category))];

//   const allIds = useMemo(() => items.map((item) => item._id), [items]);
//   const allSelected =
//     allIds.length > 0 && allIds.every((id) => selectedItems.includes(id));

//   const toggleItem = (id) => {
//     setSelectedItems((prev) =>
//       prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
//     );
//   };

//   const toggleAll = () => {
//     setSelectedItems((prev) =>
//       allSelected ? [] : [...new Set([...prev, ...allIds])]
//     );
//   };

//   const toggleCategoryExpand = (category) => {
//     setExpandedCategories((prev) =>
//       prev.includes(category)
//         ? prev.filter((c) => c !== category)
//         : [...prev, category]
//     );
//   };

//   const toggleCategorySelect = (category) => {
//     const categoryItems = items.filter((item) => item.category === category);
//     const categoryIds = categoryItems.map((item) => item._id);
//     const allCategorySelected = categoryIds.every((id) =>
//       selectedItems.includes(id)
//     );

//     setSelectedItems((prev) =>
//       allCategorySelected
//         ? prev.filter((id) => !categoryIds.includes(id))
//         : [...new Set([...prev, ...categoryIds])]
//     );
//   };

//   return (
//     <div className="w-full border border-border rounded-md p-4 bg-white space-y-4 text-sm">
//       <div className="flex items-center justify-between">
//         <h3 className="font-semibold text-base">Select {title}</h3>
//         <label
//           className="flex items-center gap-2 text-xs cursor-pointer"
//           onClick={(e) => e.stopPropagation()}
//         >
//           <input type="checkbox" checked={allSelected} onChange={toggleAll} />
//           Select All Skills
//         </label>
//       </div>

//       {categories.map((category) => {
//         const isExpanded = expandedCategories.includes(category);
//         const categoryItems = items.filter(
//           (item) => item.category === category
//         );
//         const allCategorySelected = categoryItems.every((item) =>
//           selectedItems.includes(item._id)
//         );

//         return (
//           <div key={category} className="border rounded-md mb-3">
//             <div
//               className="flex items-center justify-between cursor-pointer p-3 bg-gray-100 hover:bg-gray-200"
//               onClick={() => toggleCategoryExpand(category)}
//             >
//               <h4 className="font-medium">{category}</h4>
//               <span className="text-xs text-subMain">
//                 {isExpanded ? "▲" : "▼"}
//               </span>
//             </div>

//             {isExpanded && (
//               <div className="p-3 space-y-2 bg-white border-t">
//                 <div className="flex items-center justify-between mb-2">
//                   <span className="text-xs font-medium">Services</span>
//                   <button
//                     onClick={() => toggleCategorySelect(category)}
//                     className="text-xs underline text-subMain"
//                   >
//                     {allCategorySelected ? "Unselect All" : "Select All"}
//                   </button>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
//                   {categoryItems.map((item) => (
//                     <label
//                       key={item._id}
//                       className="flex items-center gap-2 p-2 border rounded-md cursor-pointer"
//                     >
//                       <input
//                         type="checkbox"
//                         checked={selectedItems.includes(item._id)}
//                         onChange={() => toggleItem(item._id)}
//                       />
//                       <div>
//                         <p className="font-medium">{item.title}</p>
//                         <p className="text-xs text-gray-500">
//                           {item.desc} • ${item.price}
//                         </p>
//                       </div>
//                     </label>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// time slot

export function Select({ children, selectedPerson, setSelectedPerson, datas }) {
  return (
    <div className="text-sm relative w-full ">
      <div className="w-full">
        <Listbox value={selectedPerson} onChange={setSelectedPerson}>
          <Listbox.Button className={"w-full"}>{children}</Listbox.Button>
          <Listbox.Options className="flex  flex-col gap-4 top-10 z-50 absolute left-0 w-full bg-dry rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none">
            {datas.map((person) => (
              <Listbox.Option
                className={`cursor-pointer text-xs text-text hover:text-subMain`}
                key={person.id}
                value={person}
                disabled={person.unavailable}
              >
                {person.name}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Listbox>
      </div>
    </div>
  );
}

// switch

export function Switchi({ checked, onChange }) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={`${checked ? "bg-subMain" : "bg-border"}
        relative inline-flex p-[2px] w-12 cursor-pointer rounded-full transitions`}
    >
      <span
        aria-hidden="true"
        className={`${checked ? "translate-x-5" : "translate-x-0"}
          pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg  transitions`}
      />
    </Switch>
  );
}

// textarea

export function Textarea({ label, name, register, placeholder, rows }) {
  return (
    <div className="text-sm w-full">
      <label className={"text-black text-sm"}>{label}</label>
      <textarea
        name={name}
        rows={rows}
        {...register}
        placeholder={placeholder}
        className={`focus:border-subMain w-full bg-transparent text-sm mt-3 p-4 border border-border rounded font-light 
         `}
      />
    </div>
  );
}

// date picker

export function DatePickerComp({ label, startDate, onChange }) {
  return (
    <div className="text-sm w-full">
      <label className={"text-black text-sm text-text"}>{label}</label>
      <DatePicker
        selected={startDate}
        onChange={onChange}
        className="w-full bg-transparent text-sm mt-3 p-4 border border-border font-light rounded-lg focus:border focus:border-subMain"
      />
    </div>
  );
}

// time picker

export function TimePickerComp({ label, startDate, onChange }) {
  return (
    <div className="text-sm w-full">
      <label className={"text-black text-sm"}>{label}</label>
      <DatePicker
        selected={startDate}
        onChange={onChange}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={30}
        timeCaption="Time"
        dateFormat="h:mm aa"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-border font-light rounded-lg focus:border focus:border-subMain"
      />
    </div>
  );
}

// checkbox

export function Checkbox({ label, name, onChange, checked }) {
  return (
    <div className="text-sm w-full flex flex-row items-center">
      {/* design checkbox */}
      <label className="flex-colo cursor-pointer relative">
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          className="absolute opacity-0 w-0 h-0"
        />
        <span
          className={` border rounded  w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
            checked ? "border-subMain bg-subMain" : "border-gray-300 bg-white"
          }`}
        >
          <FaCheck
            className={`text-[10px] ${checked ? "block text-white" : "hidden"}`}
          />
        </span>
      </label>

      {label && <p className={"text-black text-xs ml-2"}>{label}</p>}
    </div>
  );
}

// from to date picker

export function FromToDate({ label, startDate, onChange, endDate, bg }) {
  return (
    <div className="text-sm w-full flex flex-col gap-2">
      {label && <label className={"text-black text-sm"}>{label}</label>}
      <DatePicker
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        onChange={onChange}
        className={`w-full ${
          bg ? bg : "bg-transparent"
        }  text-xs px-4 h-14 border border-border text-main font-normal rounded-lg focus:border focus:border-subMain`}
      />
    </div>
  );
}
